// Stable identifier for this browser install.
//
// Web Bluetooth device ids are randomised per-origin AND per browser profile,
// so a saved id is only meaningful in the browser that paired it. The account
// roster stores this key alongside each device id so we know which saved rows
// can silently reconnect here and which can only be offered as a re-pair.

const STORAGE_KEY = "khronos.browserKey";

let cached = null;

const randomKey = () => {
  try {
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
      return crypto.randomUUID();
    }
  } catch {
    /* fall through */
  }
  return `bk-${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
};

/**
 * This browser's key, minted and stored on first read.
 *
 * Always returns a usable string — if storage is unavailable (private mode,
 * blocked cookies) the key lives for the lifetime of the tab instead, which
 * degrades to "this session won't sync" rather than throwing.
 */
export function getBrowserKey() {
  if (cached) return cached;
  try {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing) {
      cached = existing;
      return cached;
    }
  } catch {
    /* storage unavailable */
  }

  cached = randomKey();
  try {
    localStorage.setItem(STORAGE_KEY, cached);
  } catch {
    /* storage unavailable — key is tab-scoped this time */
  }
  return cached;
}

/** Test seam — drops the memoised value so a fresh storage state is read. */
export function resetBrowserKeyCache() {
  cached = null;
}
